import React, { useState, useContext } from 'react';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import LRTitle from '../../IMG/Logos/LR_Title_Logo.jpg';
import LRStudio from '../../IMG/Logos/LR_Studio_Colour.png'
import EdgeOrREST from '../../EdgeOrREST';
import { useDispatch } from 'react-redux';
import user from '../../store/actions/user';
import Notification from '../shared/notification.component';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../auth-provider.component';
import { setAxiosHeaders } from '../../API/services/axios.client';
import userActions from '../../store/actions/user';
import { Helmet } from 'react-helmet';

const useStyles = makeStyles((theme) => ({
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    LRTitle: {
        marginTop: theme.spacing(1),
        width: theme.spacing(29),
        height: theme.spacing(11)
    },
    LRStudio: {
        margin: theme.spacing(1),
        marginRight: theme.spacing(1.5),
        width: theme.spacing(25),
        height: theme.spacing(20)
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(2),
    },
    submit: {
        margin: theme.spacing(1, 0, 2),
    },
}));

export default function Login(props) {
    const dispatch = useDispatch();
    const { login } = useContext(AuthContext);

    const [username, setUsername] = useState(() => {
        const savedUsername = window.localStorage.getItem("username");
        return savedUsername != null ? savedUsername : '';
    });
    const [password, setPassword] = useState('');
    const [remember, setRemember] = useState(false);
    const [loading, setLoading] = useState(false);
    const [snack, setSnack] = useState({
        open: false
    });
    const classes = useStyles();
    const navigate = useNavigate();

    function Copyright() {
        return (
            <Typography variant="body2" color="textSecondary" align="center">
                {'Copyright © '}
                <Link color="inherit" href="https://lightingreality.com/">
                    Lighting Reality
                </Link>{' '}
                {new Date().getFullYear()}
            </Typography>
        );
    }

    function toForgot(props) {
        dispatch(user.UpdateUserCfg({ pathname: '/forgot' }));
        navigate('/forgot');
    }

    function submitForm(e, props, username, password, rememberMe) {
        setLoading(true);
        e.preventDefault();
        var basicAuth = 'Basic ' + btoa(username + ':' + password);
        console.log("logging in");
        EdgeOrREST(null, 'LOG_IN', onLoginAttempt, { auth: basicAuth, rememberMe, props: props });
        setLoading(false);
    }

    function onLoginAttempt(response) {
        if (response.status == "200") {
            console.log("remember", remember);
            if (response.data.token && response.data.id) {
                const requiresTwoFactor = response.data.requiresTwoFactor === true;
                const isTwoFactorVerified = response.data.isTwoFactorVerified === true;

                dispatch(userActions.UpdateUserCfg({userId: response.data.id}))
                setAxiosHeaders(response.data.token);
                console.log("username", username);
                if (remember) {
                    window.localStorage.setItem("remember", true);
                    window.localStorage.setItem("username", username);
                }
                window.localStorage.setItem("token", response.data.token);
                console.log("response login", response.data.companyId);
                console.log("response login", response.data.id);
                login(response.data.token, response.data.id, response.data.companyId, response.data.isPasswordExpiry, {
                    requiresTwoFactor,
                    isTwoFactorVerified,
                });

                if (requiresTwoFactor && !isTwoFactorVerified) {
                    dispatch(user.UpdateUserCfg({ pathname: '/2fa-setup' }));
                    navigate('/2fa-setup');
                    return;
                }

                if (response.data.isPasswordExpiry) {
                    // write to redirect to updatePassword page
                    dispatch(user.UpdateUserCfg({ pathname: '/updatePassword' }));
                    navigate('/updatePassword');
                } else {

                    dispatch(user.UpdateUserCfg({ pathname: '/launcher' }));
                    navigate('/launcher');
                }
            }
        } else {
            setSnack({
                open: true,
                message: "Your login attempt has failed. Please verify your credentials and try again later.",
                severity: 'error'
            });
        }        
    }

    const handleClose = () => {
        setSnack({
            ...snack,
            open: false
        });
    };

    return (
        <Container component="main" maxWidth="xs">
            <Helmet>
				<title>{"LR Studio"}</title>
			</Helmet>
            <CssBaseline />
            <div className={classes.paper}>
                <IconButton className="customIconButton" href="https://lightingreality.com/">
                    <Avatar className={classes.LRStudio} src={LRStudio} variant="square" />
                </IconButton>
                <Typography component="h1" variant="h5">
                    Log in
                </Typography>
                <form className={classes.form} onSubmit={(e) => submitForm(e, props, username, password, remember)}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                type="email"
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                id="email"
                                label="Email"
                                name="email"
                                autoComplete="email"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                name="password"
                                label="Password"
                                type="password"
                                id="password"
                                autoComplete="current-password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={<Checkbox value={remember} color="primary" onChange={(e) => setRemember(!remember)} />}
                                label="Remember me"
                            />
                        </Grid>
                    </Grid>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                        id="loginButton"
                        disabled={loading}
                    >
                        {loading ? "Loading..." : "Log in"}
                    </Button >
                </form>
                <Grid container justifyContent="center">
                    <Grid item>
                        <Link component="button" variant="body2" onClick={() => toForgot(props)}>
                            Forgotten password?
                        </Link>
                    </Grid>
                </Grid>
                <IconButton className="customIconButton" href="https://lightingreality.com/">
                    <Avatar className={classes.LRTitle} src={LRTitle} variant="rounded" />
                </IconButton>
                <Box mt={1}>
                    <Copyright />
                </Box>
            </div>
            <Notification onClose={handleClose} open={snack.open} severity={snack.severity} message={snack.message}></Notification>
        </Container >
    );

}


